var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPopupStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_144527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4287 23.16H6.65729C6.44432 23.16 6.27148 22.9871 6.27148 22.7742V6.16998C6.27148 5.95702 6.44432 5.78418 6.65729 5.78418H33.4287C33.6416 5.78418 33.8145 5.95702 33.8145 6.16998V22.7742C33.8145 22.9871 33.6416 23.16 33.4287 23.16ZM7.04309 22.3884H33.0429V6.55579H7.04309V22.3884Z",
    fill: "#3158C4",
    stroke: "#3158C4",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1627 34.2141H4.91914C4.80648 34.2141 4.69923 34.1647 4.62593 34.0791C4.55263 33.9934 4.52022 33.88 4.53797 33.7681L6.27408 22.7133C6.3034 22.5258 6.46544 22.3877 6.65525 22.3877H33.4266C33.6164 22.3877 33.7785 22.5258 33.8078 22.7133L35.5439 33.7681C35.5616 33.8792 35.5292 33.9934 35.4559 34.0791C35.3826 34.1647 35.2754 34.2141 35.1627 34.2141ZM5.37053 33.4425H34.7121L33.0971 23.1593H6.9855L5.37053 33.4425Z",
    fill: "#3158C4",
    stroke: "#3158C4",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5738 10.7872H10.1417C9.9287 10.7872 9.75586 10.6144 9.75586 10.4014C9.75586 10.1885 9.9287 10.0156 10.1417 10.0156H14.5738C14.7867 10.0156 14.9596 10.1885 14.9596 10.4014C14.9596 10.6144 14.7867 10.7872 14.5738 10.7872Z",
    fill: "#3158C4",
    stroke: "#3158C4",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.512 13.9122H10.1417C9.9287 13.9122 9.75586 13.7394 9.75586 13.5264C9.75586 13.3135 9.9287 13.1406 10.1417 13.1406H17.512C17.725 13.1406 17.8978 13.3135 17.8978 13.5264C17.8978 13.7394 17.725 13.9122 17.512 13.9122Z",
    fill: "#3158C4",
    stroke: "#3158C4",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5738 19.1808H10.1417C9.9287 19.1808 9.75586 19.0079 9.75586 18.795C9.75586 18.582 9.9287 18.4092 10.1417 18.4092H14.5738C14.7867 18.4092 14.9596 18.582 14.9596 18.795C14.9596 19.0079 14.7867 19.1808 14.5738 19.1808Z",
    fill: "#3158C4",
    stroke: "#3158C4",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9404 16.5118H24.2159C24.0029 16.5118 23.8301 16.3389 23.8301 16.126V10.4014C23.8301 10.1885 24.0029 10.0156 24.2159 10.0156H29.9404C30.1534 10.0156 30.3262 10.1885 30.3262 10.4014V16.126C30.3262 16.3389 30.1534 16.5118 29.9404 16.5118ZM24.6017 15.7402H29.5546V10.7872H24.6017V15.7402Z",
    fill: "#3158C4",
    stroke: "#3158C4",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.8245,
    cy: 24.5237,
    r: 7.10769,
    fill: "white",
    stroke: "#3158C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9804 26.7108L28.9922 24.7227",
    stroke: "#3158C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3544 22.3379L30.9805 26.7119",
    stroke: "#3158C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_144527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPopupStep4);
export default __webpack_public_path__ + "static/media/ico_popup_step4.2896054676e286d430b5c1818d6ee885.svg";
export { ForwardRef as ReactComponent };